import React, { Component, Fragment } from 'react';
import autobind from 'autobind-decorator';
import classnames from 'classnames';
import WindowEventHelper from '../../../../lib/WindowEventHelper';
import { isDescendant } from '../../../../lib/DomUtils';
import MenuItem from './MenuItem';
import TinymceFloatPanel from '../../../common/TinymceFloatPanel';

function findSelectedItem (items, value) {
  let selected = items.find(item => item.value == value);
  if (!selected) {
    selected = items.flatMap(item => (item.subItems ? item.subItems : [])).find(item => item.value == value);
  }

  return selected || items[0];
}

class SelectMenuButton extends Component {
  constructor (props) {
    super(props);
    this.state = {
      openMenu: false,
    };

    this.menu = React.createRef();
  }

  componentDidMount () {
    WindowEventHelper.add('click', this.handleWindowClick);
  }

  componentWillUnmount () {
    WindowEventHelper.remove('click', this.handleWindowClick);
  }

  @autobind
  handleWindowClick (e) {
    const { openMenu } = this.state;
    if (!openMenu) {
      return;
    }

    if (!isDescendant(this.menu.current, e.target)) {
      this.handleCloseMenu();
    }
  }

  @autobind
  handleToggleMenu () {
    const { openMenu } = this.state;
    if (openMenu) {
      this.handleCloseMenu();
    } else {
      this.handleOpenMenu();
    }
  }

  @autobind
  handleOpenMenu () {
    this.setState({
      openMenu: true,
    });
  }

  @autobind
  handleCloseMenu () {
    this.setState({
      openMenu: false,
    });
  }

  @autobind
  handleSelect (item) {
    const { onSelect } = this.props;
    onSelect(item.value);
    this.handleCloseMenu();
  }

  render () {
    const { menus, value, width, disabled } = this.props;
    const { openMenu } = this.state;
    const selected = findSelectedItem(menus, value);

    return (
      <div ref={this.menu} className="mce-widget mce-btn select-menu">
        <button type="button" className={classnames('mce-btn-type1', { 'mce-opened': openMenu })} onClick={this.handleToggleMenu} disabled={disabled}>
          <i className="mce-txt">{selected.label}</i>
          <i className="mce-caret">더보기</i>
        </button>

        {!disabled && openMenu &&
          <TinymceFloatPanel style={{ width }}>
            {menus.map(item => <Fragment key={item.value}>
              <MenuItem
                key={item.value}
                item={item} disabled={!!item.subItems}
                onSelect={this.handleSelect}
              />

              {item.subItems && item.subItems.map(subItem => ({ value: subItem.value, label: `- ${subItem.label}` })).map(subItem => <MenuItem
                key={subItem.value}
                item={subItem} disabled={false}
                onSelect={this.handleSelect}
              />
              )}
            </Fragment>
            )}
          </TinymceFloatPanel>
        }
      </div>
    );
  }
}

export default SelectMenuButton;
